import React from 'react'
import GooglePlayBadge from 'assets/images/google-play-badge-en-us.png'
import AppStoreBadge from 'assets/images/app-store-badge-en-us.png'
import QRCode from 'react-qr-code'
import { useIntl } from 'react-intl'

type MobileAppStoreBadgesProps = {
	universalUrl: string
	appStoreUrl: string
	googlePlayUrl: string
}

export default function MobileAppStoreBadges({
	universalUrl,
	appStoreUrl,
	googlePlayUrl,
}: MobileAppStoreBadgesProps) {
	const { formatMessage } = useIntl()
	return (
		<div className="border-2 rounded-xl p-5 flex flex-col gap-4 self-start">
			<p className="text-lg font-rubik text-black font-semibold dark:text-white text-center">
				{formatMessage({
					id: 'mobile_settings.download_our_mobile_app',
				})}
			</p>
			<div className="flex flex-row gap-3">
				<QRCode value={universalUrl} size={110} />
				<div className="flex flex-col gap-3">
					<a href={googlePlayUrl} target="_blank" rel="noreferrer">
						<img
							src={GooglePlayBadge}
							className="w-40 h-auto"
							alt={formatMessage({
								id: 'mobile_settings.download_it_on_google_play',
							})}
						/>
					</a>
					<a href={appStoreUrl} target="_blank" rel="noreferrer">
						<img
							src={AppStoreBadge}
							className="w-40 h-auto"
							alt={formatMessage({
								id: 'mobile_settings.download_it_on_app_store',
							})}
						/>
					</a>
				</div>
			</div>
		</div>
	)
}
